export default "__VITE_ASSET__Bd6N96mj__"